import request from '@/libs/request'

// 牛场经销商 列表
export function cattleSlaughterSalesListApi (data) {
  return request({
    url: `cattleFarm/cattleSlaughterSales`,
    method: 'get',
    params: data
  })
}

// 牛场经销商 详情
export function cattleSlaughterSalesDetailApi (id) {
  return request({
    url: `cattleFarm/cattleSlaughterSales/` + id,
    method: 'get'
  })
}


// 牛场经销商 编辑/添加
export function cattleSlaughterSalesSaveApi (data) {
  return request({
    url: `cattleFarm/cattleSlaughterSales`,
    method: 'post',
    data: data
  })
}

// 牛场经销商 删除
export function cattleSlaughterSalesDelApi (id) {
  return request({
    url: `cattleFarm/cattleSlaughterSales/` + id,
    method: 'delete'
  })
}

//牛场经销商 所有数据
export function cattleSlaughterSalesAllApi (data = {}) {
  return request({
    url: `cattleFarm/cattleSlaughterSalesApi/all`,
    method: 'get',
    params: data
  })
}


